
import React from 'react';
import { Theme } from '@core-ui/react-stitch/types';

interface FilterIconProps {
  width?: string,
  height?: string
}
const FilterIcon = ({ width = '18px', height = '15px' }: FilterIconProps) => {
  const strokeStyles = (theme: Theme) => ({ stroke: theme.color.b1 });

  return (
    <svg height={height} version="1.1" viewBox="0 0 18 15" width={width} xmlns="http://www.w3.org/2000/svg">
      <title>Filter icon</title>
      <g fill="none" fillRule="evenodd" id="filterIcon" stroke="none" strokeWidth="1">
        <g css={strokeStyles} id="CP-DROPDOWN" transform="translate(-44.000000, -724.000000)">
          <g id="Facet-Section" transform="translate(24.000000, 668.000000)">
            <g id="Dashboard/Filters" transform="translate(2.000000, 28.000000)">
              <g id="Filter/CTA" transform="translate(16.000000, 10.000000)">
                <g id="Filter-icon" transform="translate(2.000000, 19.000000)">
                  <line id="Line-2" strokeLinecap="square" strokeWidth="1.008" x1="0.542" x2="16.642" y1="1.72" y2="1.72" />
                  <line id="Line-2-Copy" strokeLinecap="square" strokeWidth="1.008" x1="0.542" x2="16.642" y1="6.968" y2="6.968" />
                  <line id="Line-2-Copy-2" strokeLinecap="square" strokeWidth="1.008" x1="0.542" x2="16.642" y1="12.216" y2="12.216" />
                  <circle cx="4" cy="1.6" fill="#FFFFFF" id="Oval" r="1.6" strokeWidth="0.8" />
                  <circle cx="4" cy="12" fill="#FFFFFF" id="Oval" r="1.6" strokeWidth="0.8" />
                  <circle cx="12.128" cy="7.056" fill="#FFFFFF" id="Oval-Copy" r="1.6" strokeWidth="0.8" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

FilterIcon.defaultProps = {
  width : '18px', 
  height : '15px'
};

export default FilterIcon;
